import { useState } from "react"
import { post } from "../../../../config/services/api/ApiServices"
import { useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/Index";

export const BayInOut = ({ selectedBay, setSelectedBay, tripData, reload }: any) => {
    const user = useAppSelector((state: RootState) => state.user);
    const auth = useAppSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false)

    const onChange = (e: any) => {
        setSelectedBay(e.target.value)
    }

    const handleClick = async () => {
        setLoading(true)
        if((tripData?.bayInButton == "Active" || tripData?.bayOutButton == "Active")){
            const header = {
                "Content-Type": 'application/json',
                "Authorization": auth.jwToken
            }
            const res = await post(`Trips/${tripData?.bayInButton == "Active" ? "BayIn" : (tripData?.bayOutButton == "Active" ? "BayOut" : "")}`, {
                "bayID": (typeof(selectedBay) == "object" ? selectedBay?.id : selectedBay)?.toString(),
                "tripID": tripData?.id,
                "userID": user.userID,
                "userType": user.userType
            }, header)
            reload()
            alert(res?.message || "Something went wrong")
        }
        setLoading(false)
    }

    return (
        <div className="my-3">
            <strong>Bay Mapping</strong>
            <div className="d-flex">
                <select value={selectedBay ? selectedBay?.id : ""} onChange={onChange} className="form-control" style={{ width: 300 }} disabled={tripData?.bayOutButton == "Active"}>
                    <option value={""}>--select bay--</option>
                    {tripData?.availableBays?.map((item: any) => <option value={item?.id}>{item?.bayName}</option>)}
                </select>

                {(tripData?.bayInButton == "Active" || tripData?.bayOutButton == "Active") && <input type="button" value={tripData?.bayInButton == "Active" ? "Bay In" : (tripData?.bayOutButton == "Active" ? "Bay Out" : "")} className={`btn btn-sm ${selectedBay ? "btn-success" : "btn-secondary"} ms-2 px-4`} disabled={loading || !selectedBay} onClick={handleClick}/>}
            </div>
        </div>
    )
}